import React from 'react';
import { ServiceCreateMutation } from '../graphql/mutations/ServiceCreateMutation';
import { EntityEditFetcher } from '../components/EntityEditFetcher';
import typeIntro from '../static/introspection/Service.json';
import inputTypeIntro from '../static/introspection/ServiceCreateInput.json';
import { ServiceEditQuery } from '../graphql/query/ServiceEditQuery';
import { ENTITY } from '../utils/entities';
import { graphqlQuery } from '../utils/graphql';
import { UserData } from '@food/auth';

export const ServiceCreate = ({ id }) => (
	<UserData>
		{({ isInternal }) => (
			<EntityEditFetcher
				fetcher={id ? graphqlQuery(ServiceEditQuery, { id }) : null}
				create={true}
				clone={!!id}
				id={id}
				mutation={ServiceCreateMutation}
				typeIntro={typeIntro}
				inputTypeIntro={inputTypeIntro}
				entityName={ENTITY.SERVICE}
				fields={[
					isInternal ? 'sfId' : null,
					'name',
					'logoMedia',
					'type',
					'billingName',
					'description',
					'descriptionIta',
					'descriptionLong',
					'descriptionLongIta',
					'pecEmail',
					'vatNumber',
					'website',
					'Country',
					'StateProvince',
					'postalCode',
					'city',
					'address1',
					'address2',
					'lat',
					'lng',
				]}
			/>
		)}
	</UserData>
);
